import AsideElementFill from "./AsideElementFill";
import AsideElementFunction from "./AsideElementFunction";
import AsideElementGlobal from "./AsideElementGlobal";
import AsideElementNavigation from "./AsideElementNavigation";
import AsideElementOptions from "./AsideElementOptions";

function AsideElementOverview({
  showGlobals,
  setShowGlobals,
  nameFunction,
  showFunction,
  setShowFunction,
  showConditions,
  setShowConditions,
}) {
  return (
    <>
      <AsideElementOptions />
      <AsideElementGlobal showGlobals={showGlobals} setShowGlobals={setShowGlobals} />
      <AsideElementFunction />
      <AsideElementNavigation
        name={nameFunction}
        showFunction={showFunction}
        setShowFunction={setShowFunction}
        showConditions={showConditions}
        setShowConditions={setShowConditions}
      />
      <AsideElementFill />
    </>
  );
}

export default AsideElementOverview;
